import request from '@/utils/request';
import { ResCode } from './baseDefine';
export interface GetMeterReq {
    meterID: number;
    timeID: number;
    date: string;
    type: number;
    lineData: boolean;
}
export interface HistoryRes {
    code: ResCode;
    msg: string;
    data: HistorysData;
}
export interface HistorysData {
    history: HistoryList;
    monthData: MonthData;
    installDate: string;
    meterID: string;
}
export interface MonthData {
    usage: number;  // 用量
    money: number;  // 费用
}
export interface HistoryList {
    list: History[];
    base: number;
}

export interface History {
    usage: number;  // 用量
    money: number;  // 费用
    importEnergyUsage: number;
    exportEnergyUsage: number;
    pvEnergyUsage: number;
    pyranometerUsage: number;
    pulseCountUsage: number;
    time: string;   // 时间
    reading: number;
    Current1: number;
    Voltage1: number;
    Frequency1: number;
    ActivePower1: number;
    ReactivePower1: number;
    Current2: number;
    Voltage2: number;
    Frequency2: number;
    ActivePower2: number;
    ReactivePower2: number;
    Current3: number;
    Voltage3: number;
    Frequency3: number;
    ActivePower3: number;
    ReactivePower3: number;
    lineDatas: number[];
    temperature: number;
    humidity: number;
    pvExportEnergyUsage: number;
    routeBImportEnergyUsage: number;
    routeBExportEnergyUsage: number;
}


export function getMeterData(req: GetMeterReq): Promise<HistoryRes> {
    return request.post<HistoryRes>('/api/home/history', req);
}
